// import can from '@/router/middleware/can'

import auth from '../../middleware/auth'

export default [
  {
    path: '/telemetry',
    name: 'Telemetry',
    redirect: { name: 'TelemetryBeverageSales' },
    meta: {
      middleware: [auth],
      title: 'telemetry',
      breadCrumb: [{ text: 'telemetry' }]
    }
  },
  {
    path: '/telemetry/beverage-sales',
    name: 'TelemetryBeverageSales',
    component: () =>
      import(
        /* webpackChunkName: "telemetryBeverageSales" */ '@/pages/telemetry/charts/ChartsIndex'
      ),
    meta: {
      middleware: [auth],
      title: 'beverageSales',
      breadCrumb: [
        { text: 'telemetry' },
        { text: 'beverageSales' }
      ]
    }
  },
  {
    path: '/telemetry/total-sales',
    name: 'TelemetryTotalSales',
    component: () =>
      import(
        /* webpackChunkName: "telemetryTotalSales" */ '@/pages/telemetry/total-sales/TotalSalesIndex'
      ),
    meta: {
      middleware: [auth],
      title: 'totalSales',
      breadCrumb: [
        { text: 'telemetry' },
        { text: 'totalSales' }
      ]
    }
  },
//   {
//     path: '/telemetry/:telemetryId',
//     name: 'TelemetryShow',
//     component: () =>
//       import(
//         /* webpackChunkName: "telemetryShow" */ '@/pages/telemetry/TelemetryShow'
//       ),
//     props: true,
//     meta: {
//       middleware: [can('isTelemetryShow'), auth],
//       title: 'telemetry',
//       breadCrumb: [
//         { text: 'telemetry', to: { name: 'Telemetry' } },
//         { text: undefined }
//       ]
//     }
//   }
]
